import { TFunction } from 'i18next';

interface PluralKeys {
  zero: string;
  one: string;
  singular: string;
  few: string;
  many: string;
}

export const getPlural = (
  count: number | undefined,
  t: TFunction,
  keys: PluralKeys,
  interpolation = 'count'
): string => {
  if (count === undefined || count <= 0) {
    return t(keys.zero);
  }

  const lastTwo = count % 100;
  const lastOne = count % 10;

  if (lastTwo >= 11 && lastTwo <= 14) {
    return t(keys.many, { [interpolation]: count });
  }

  if (lastOne === 1) {
    return count === 1
      ? t(keys.one)
      : t(keys.singular, { [interpolation]: count });
  }

  if (lastOne >= 2 && lastOne <= 4) {
    return t(keys.few, { [interpolation]: count });
  }

  return t(keys.many, { [interpolation]: count });
};